export const DIDO_DOCUMENTEN_CONTROL_SHARED_I18N = {
    ACTION: {
        RESET_FILTER: 'Filters initialiseren',
        //'RESET_STANDAARD': 'Instellingen terugzetten naar default waarden',
        RESET_FILTER_INFO: 'De filters zijn teruggezet naar de initi&eumlle waarden.',
        //'RESET_STANDARD_INFO': 'De instellingen zijn teruggezet naar initi�le waarden',
        EXPORT_EXCEL: 'Exporteren naar Excel',
        EXPORT_EXCEL_FILENAME: 'Export',
        EXPORT_EXCEL_SHEETNAME: 'Export',
        EXPORT_EXCEL_ZICHTBAAR: 'zichtbaar',
        EXPORT_EXCEL_NIETZICHTBAAR: 'niet zichtbaar',
        EXPORT_EXCEL_JA: 'ja',
        EXPORT_EXCEL_NEEN: 'neen',
        //'DELETE_SETTINGS': 'Verwijderen instellingen',
        //'SAVE_SETTINGS': 'Mijn instellingen bewaren',
        INITIALIZE_SETTINGS: 'Instellingen initialiseren',
        APPLY_SETTINGS: 'Mijn instellingen toepassen',
        //'DELETE_SETTINGS_TOOLTIP': 'Verwijderen bewaarde instellingen',
        SAVE_SETTINGS_TOOLTIP: 'Bewaren instellingen',
        SETTINGS: 'Instellingen',
        DOWNLOAD_ALL: 'Download alle documenten als ZIP'
    },
    GEBRUIKERSVOORKEUREN: {
        //'SAVED': "Mijn instellingen zijn bewaard.",
        INITIALIZED_SAVED: 'Mijn instellingen zijn toegepast.'
        //'DELETED': "Bewaarde instellingen werden verwijderd",
        //'DELETE_TITLE': "Verwijderen bewaarde instellingen",
        //'ARE_YOU_SURE_DELETE': 'Bent u zeker dat u de bewaarde instellingen wilt verwijderen?',
        //'SAVE_TITLE': "Bewaren instellingen",
        //'ARE_YOU_SURE_SAVE': 'Bent u zeker dat u de huidige instellingen wilt bewaren?',
        //'SAVE_ERROR': 'Fout bij bewaren instellingen',
        //'DELETE_ERROR': 'Fout bij verwijderen bewaarde instellingen',
    }
} as const;
